var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"min-width":"320px"}},[_c('v-card-text',[_c('b',[_vm._v("Attendance")]),_vm._v(" - The percentage of days that students were present based on student attendance for the entire school year.\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }